import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.5 4.5h2.25m-1.5 3.75h6m-6 3.75h6m-6 3.75h6m-6 3.75h3M19.5.75H21a1.5 1.5 0 0 1 1.5 1.5V6.5a1 1 0 0 1-1 1H18h0V2.25a1.5 1.5 0 0 1 1.5-1.5"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20.25.75H7.5a3 3 0 0 0-3 3v15c0 3-1.5 3.876-3 4.5h12a4.5 4.5 0 0 0 4.5-4.5V7.5"
    }, null, -1)
  ]));
}
const moneyCashierReceipt = { render };
export {
  moneyCashierReceipt as default,
  render
};
//# sourceMappingURL=money-cashier-receipt.svg.js.map
